import { render, staticRenderFns } from "./AppStaffGrid4Block.vue?vue&type=template&id=5a833472&scoped=true"
import script from "./AppStaffGrid4Block.vue?vue&type=script&lang=js"
export * from "./AppStaffGrid4Block.vue?vue&type=script&lang=js"
import style0 from "./AppStaffGrid4Block.vue?vue&type=style&index=0&id=5a833472&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a833472",
  null
  
)

export default component.exports